import $ from '../../../vendor/js/jquery';
import '../../../vendor/js/jquery.nivo.slider';
import '../../../vendor/js/owl.carousel';
import style from './style.scss';

export default function ($scope, $rootScope, $timeout, $http) {
    'ngInject';
    $scope.style = style;

    const loadSlides = () => {
        if ($rootScope.slides && $rootScope.slides.length > 0) {
            $timeout(() => {
                $('#ensign-nivoslider').nivoSlider({
                    effect: 'random',
                    slices: 15,
                    boxCols: 8,
                    boxRows: 4,
                    animSpeed: 500,
                    pauseTime: 5000,
                    startSlide: 0,
                    directionNav: true,
                    controlNavThumbs: false,
                    pauseOnHover: true,
                    manualAdvance: false
                });
            }, 100);
        }
    };

    loadSlides();
    $scope.$on('onLoadGeneral', () => {
        loadSlides();
    });

    $http.get($scope.backURL + 'application/site/home').then(function (data) {

        $scope.categorias = data.data.categorias;
        $scope.banners = data.data.banners;

        console.log($rootScope.slides);

        // Lançamentos
        // $scope.produtos.lancamentos = data.data.lancamentos;        

        // Central Multimidia
        $scope.produtos.centralMultimidia = data.data['central-multimidia'];
        $scope.produtos.lancamentos = ($scope.produtos.centralMultimidia || []).splice(0, 6).map(produto => $rootScope.configProduto(produto));
        $scope.produtos.maisvendidos = [];
        $scope.produtos.maisvendidos.push(($scope.produtos.centralMultimidia || []).splice(0, 3).map(produto => $rootScope.configProduto(produto)));
        $scope.produtos.maisvendidos.push(($scope.produtos.centralMultimidia || []).splice(0, 3).map(produto => $rootScope.configProduto(produto)));
        $scope.produtos.centralMultimidia = ($scope.produtos.centralMultimidia || []).map(produto => $rootScope.configProduto(produto));

        /* / DJ Profissional
        $scope.produtos.djProfissional = data.data['dj-profissional'];
        cat = $scope.produtos.djProfissional || [];
        for (i = 0; i < cat.length; i++) {
          cat[i] = $rootScope.configProduto(cat[i]);
        }

        // Receptores
        $scope.produtos.receptores = data.data['receptores'];
        cat = $scope.produtos.receptores || [];
        for (i = 0; i < cat.length; i++) {
          cat[i] = $rootScope.configProduto(cat[i]);
        }

        // Perfumaria
        $scope.produtos.perfumaria = data.data['perfumes'];
        cat = $scope.produtos.perfumaria || [];
        for (i = 0; i < cat.length; i++) {
          cat[i] = $rootScope.configProduto(cat[i]);
        }

        // Tabacaria
        $scope.produtos.tabacaria = data.data['tabacaria'];
        cat = $scope.produtos.tabacaria || [];
        for (i = 0; i < cat.length; i++) {
          cat[i] = $rootScope.configProduto(cat[i]);
        } */

        $timeout(() => {
            $('.features-crousel').owlCarousel({
                autoPlay: true, 
                slideSpeed: 2000,
                pagination: false,
                navigation: true,	  
                items: 4,
                navigationText: ['<i class=\'fa fa-angle-left\'></i>', '<i class=\'fa fa-angle-right\'></i>'],
                itemsDesktop: [1199, 4],
                itemsDesktopSmall: [980, 3],
                itemsTablet: [768, 2],
                itemsMobile: [479, 1]
            });

            $('.best-seller-crousel').owlCarousel({
                autoPlay: true, 
                slideSpeed: 2000,
                pagination: false,
                navigation: true,	  
                items: 1,
                navigationText: ['<i class=\'fa fa-angle-left\'></i>', '<i class=\'fa fa-angle-right\'></i>'],
                singleItem: true
            });

            $('.new-product-crousel').owlCarousel({
                autoPlay: true, 
                slideSpeed: 2000,
                pagination: false,
                navigation: true,	  
                items: 3,
                navigationText: ['<i class=\'fa fa-angle-left\'></i>', '<i class=\'fa fa-angle-right\'></i>'],
                itemsDesktop: [1199, 3],
                itemsDesktopSmall: [980, 2],
                itemsTablet: [768, 2],
                itemsMobile: [479, 1]
            });
        }, 100);

    }, function () {});

}



// WEBPACK FOOTER //
// ./src/app/views/app.home/index.js